import { getLocalTimeZone, parseAbsolute, toCalendarDateTime, toTimeZone } from "@internationalized/date";

export const formatAbsoluteToZonedDateTime = (date: Date, renderTimezone?: string) => {
  const localZonedDateTime = parseAbsolute(date.toISOString(), getLocalTimeZone());

  return renderTimezone ? toTimeZone(localZonedDateTime, renderTimezone) : localZonedDateTime;
};

export const getDateParts = (date: Date, renderTimezone?: string) => {
  const zonedDateTime = formatAbsoluteToZonedDateTime(date, renderTimezone);
  const calendarDateTime = toCalendarDateTime(zonedDateTime);

  return {
    zonedDateTime,
    time: calendarDateTime,
  };
};
